// ContactScreen.js
import React, {useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  TextInput,
  Linking,
  Alert,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';

const ContactScreen = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const contactInfo = [
    {
      id: 1,
      icon: 'phone',
      title: 'মোবাইল',
      info: '01771-33 55 77',
      action: 'tel:+01771-33 55 77',
    },
    {
      id: 2,
      icon: 'email',
      title: 'ইমেইল',
      info: 'bdlawservice@gmail.com',
      action: 'mailto:bdlawservice@gmail.com',
    },
    {
      id: 3,
      icon: 'location-on',
      title: 'ঠিকানা',
      info: 'Room No- 45 & 60, (Ground Floor) Supreme Court Bar Association Bhaban, Shahbagh, Dhaka-1000,',
      action: null,
    },
    {
      id: 4,
      icon: 'schedule',
      title: 'সেবা সময়',
      info: 'রবি - বৃহস্পতি: সকাল ৯টা - বিকাল ৪টা',
      action: null,
    },
  ];

  const handleSendMessage = () => {
    if (!name.trim() || !email.trim() || !message.trim()) {
      Alert.alert('সতর্কতা', 'দয়া করে সব ফিল্ড পূরণ করুন');
      return;
    }
    Alert.alert('সফল', 'আপনার বার্তা পাঠানো হয়েছে');
    setName('');
    setEmail('');
    setMessage('');
  };

  const handleContactAction = action => {
    if (action) {
      Linking.openURL(action).catch(() => {
        Alert.alert('ত্রুটি', 'এই অ্যাপ্লিকেশনটি খোলা সম্ভব হয়নি');
      });
    }
  };

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>যোগাযোগ করুন</Text>
        <Text style={styles.headerSubtitle}>ঢাকা জেলা ও দায়রা জজ আদালত</Text>
      </View>

      {/* Contact Cards */}
      <View style={styles.contactGrid}>
        {contactInfo.map(item => (
          <TouchableOpacity
            key={item.id}
            style={styles.contactCard}
            onPress={() => handleContactAction(item.action)}
            activeOpacity={item.action ? 0.7 : 1}
          >
            <View style={styles.contactIcon}>
              <Icon name={item.icon} size={28} color="#307ecc" />
            </View>
            <Text style={styles.contactTitle}>{item.title}</Text>
            <Text style={styles.contactInfo}>{item.info}</Text>
          </TouchableOpacity>
        ))}
      </View>

      {/* Contact Form */}
      <View style={styles.formContainer}>
        <Text style={styles.formTitle}>বার্তা পাঠান</Text>

        <View style={styles.inputGroup}>
          <Icon name="person" size={20} color="#666" style={styles.inputIcon} />
          <TextInput
            style={styles.input}
            placeholder="আপনার নাম"
            value={name}
            onChangeText={setName}
            placeholderTextColor="#999"
          />
        </View>

        <View style={styles.inputGroup}>
          <Icon name="email" size={20} color="#666" style={styles.inputIcon} />
          <TextInput
            style={styles.input}
            placeholder="আপনার ইমেইল"
            value={email}
            onChangeText={setEmail}
            keyboardType="email-address"
            placeholderTextColor="#999"
          />
        </View>

        <View style={[styles.inputGroup, styles.textAreaGroup]}>
          <Icon
            name="message"
            size={20}
            color="#666"
            style={styles.inputIcon}
          />
          <TextInput
            style={[styles.input, styles.textArea]}
            placeholder="আপনার বার্তা"
            value={message}
            onChangeText={setMessage}
            multiline
            numberOfLines={4}
            placeholderTextColor="#999"
          />
        </View>

        <TouchableOpacity style={styles.sendButton} onPress={handleSendMessage}>
          <Text style={styles.sendButtonText}>বার্তা পাঠান</Text>
          <Icon name="send" size={20} color="#fff" />
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  header: {
    backgroundColor: '#307ecc',
    padding: 20,
    paddingTop: 40,
    paddingBottom: 30,
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#fff',
  },
  headerSubtitle: {
    fontSize: 14,
    color: '#fff',
    opacity: 0.9,
    marginTop: 4,
  },
  contactGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: 15,
    marginTop: -15,
  },
  contactCard: {
    backgroundColor: '#fff',
    width: '48%',
    padding: 15,
    borderRadius: 12,
    alignItems: 'center',
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 2,
  },
  contactIcon: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: '#e8f0fe',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  contactTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  contactInfo: {
    fontSize: 11,
    color: '#666',
    textAlign: 'center',
    marginTop: 4,
  },
  formContainer: {
    backgroundColor: '#fff',
    margin: 15,
    padding: 20,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 2,
    marginBottom: 30,
  },
  formTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 15,
  },
  inputGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#e0e0e0',
    borderRadius: 8,
    marginBottom: 12,
    paddingHorizontal: 12,
    backgroundColor: '#fafafa',
  },
  inputIcon: {
    marginRight: 10,
  },
  input: {
    flex: 1,
    height: 45,
    fontSize: 15,
    color: '#333',
  },
  textAreaGroup: {
    alignItems: 'flex-start',
    paddingTop: 10,
  },
  textArea: {
    height: 80,
    textAlignVertical: 'top',
  },
  sendButton: {
    backgroundColor: '#307ecc',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 12,
    borderRadius: 8,
    marginTop: 5,
  },
  sendButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    marginRight: 10,
  },
});

export default ContactScreen;
